import {configureStore, combineReducers} from "@reduxjs/toolkit";
import {TypedUseSelectorHook, useDispatch, useSelector} from "react-redux";
import authReduser from './redusers/authSlice'
import appReduser from './redusers/appSlice'
import loaderReduser from './redusers/loaderSlice'

const rootReduser = combineReducers({
  authReduser,
  appReduser,
  loaderReduser
})

export const setupStore = () => {
  return configureStore({
    reducer: rootReduser
  })
}

type RootState = ReturnType<typeof rootReduser>
type AppStore = ReturnType<typeof setupStore>
export type AppDispatch = AppStore['dispatch']

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
